import type { PartDamageType } from '@/types/rc/miners'
import type { PartDiagnosticStatus, PartStatus } from '@/types/rc/miners/PartStatus'
import type { IndividualPart, PartType } from '@/types/rc/miners//PartType'
import type { UploadFile } from 'element-plus'

export interface IStartScanningSessionForm {
  customer?: any
  workOrderNumber?: string
  shipment?: any
}

export type IMinerUpdateForm = { repair_notes: string } | { performed_services: number[] } | { hashboard_only: boolean }

export interface IMinerDiagnosticForm {
  date: Date
  result: 'Pass' | 'Fail' | null
  failure_reasons?: string
  files?: UploadFile[]
}

export interface IMinerPartRepairmentForm {
  part_id: number
  part_type: PartType
  status?: PartStatus | null
  repair_notes?: string
  initial_diagnostic_data?: {
    initial_diagnostic?: PartDiagnosticStatus | null
    failure_type_id?: number
    comment?: string
  }
}

export interface IUpdateFailureForm {
  failure_type_id?: number
  comment?: string
  executed_repair_action_id?: number
}

export interface IStressTestForm {
  date?: Date
  result: 'Pass' | 'Fail'
  failure_reason?: string
  files?: UploadFile[]
}

export enum ConsolidationAction {
  Swap = 'swap',
  Movement = 'movement',
}

export interface IConsolidationAction {
  undo?: {
    left_column: number
    left_part_name: IndividualPart
    right_column: number
    right_part_name: IndividualPart
  }
  action: ConsolidationAction
  part_type: PartType
  left_miner_id: number
  left_part_id: number
  right_miner_id: number
  right_part_id?: number // required for swaps
  right_part_number?: number // required for movements
}

export interface IPartDamageCreationForm {
  part_id: number
  part_type: PartType
  damage_type: PartDamageType
  description: string
  pictures: File[]
}

export interface IPartDamageDeletionForm {
  part_id: number
  part_type: PartType
  damage_id: number
}
